/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { T } from "../Localization";
import { FormRenderingStatus } from "../Constants/FormStatus";
import { HtmlAttributes } from "../../../../Common/Constants/HtmlAttributes";
import { isEventManagementForm } from "../Utils/FormUtils";
import { EventFormSubmissionTypes, WaitlistOptions } from "./Constants";
import { FormUtility } from "../FormUtility";
var EventFormRender = /** @class */ (function () {
    function EventFormRender() {
    }
    EventFormRender.render = function (form, placeholder, renderingStatus) {
        var _this = this;
        if (!isEventManagementForm(form)) {
            return;
        }
        if (FormUtility.isEventCancelationForm()) {
            this.renderCancelationForm(placeholder, renderingStatus);
            return;
        }
        Array.prototype.forEach.call(placeholder.querySelectorAll("[type='submit']"), function (button, i) { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = renderingStatus;
                        switch (_a) {
                            case FormRenderingStatus.EventWaitlisted: return [3 /*break*/, 1];
                            case FormRenderingStatus.EventCapacityIsFull: return [3 /*break*/, 3];
                        }
                        return [3 /*break*/, 4];
                    case 1:
                        this.setSubmissionType(button, "waitlist");
                        _b = button;
                        return [4 /*yield*/, T("JoinWaitlistButtonLabel")];
                    case 2:
                        _b.innerText = _c.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        button.disabled = true;
                        return [3 /*break*/, 5];
                    case 4:
                        this.setSubmissionType(button, "registration");
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); });
        this.renderSessions(placeholder);
    };
    EventFormRender.setSessionSelectionListeners = function (placeholder) {
        var _this = this;
        var sessionsBlock = placeholder.querySelector("div[".concat(HtmlAttributes.blockType, "=\"Sessions\"]"));
        var sessionSelectionRequiredAttribute = sessionsBlock === null || sessionsBlock === void 0 ? void 0 : sessionsBlock.getAttribute(HtmlAttributes.dataRequiredForCancel);
        var isSessionSelectionRequired = sessionSelectionRequiredAttribute && sessionSelectionRequiredAttribute === "True";
        var sessionRegistrationCancelButton = placeholder.querySelector("button[".concat(HtmlAttributes.dataEventSubmissionType, "=\"").concat(EventFormSubmissionTypes.sessionRegistrationCancellation, "\"]"));
        var selectAllSessionsCheckbox = placeholder.querySelector('.selectAllSessions input[type="checkbox"]');
        var sessionCheckboxes = placeholder.querySelectorAll('.eventSessions .eventSession input[type="checkbox"]');
        if (selectAllSessionsCheckbox && selectAllSessionsCheckbox instanceof HTMLInputElement) {
            selectAllSessionsCheckbox.addEventListener("click", function (event) {
                if (sessionCheckboxes.length > 0) {
                    sessionCheckboxes.forEach(function (checkbox) {
                        var _a;
                        checkbox.checked = !!((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.checked);
                    });
                    sessionCheckboxes[0].dispatchEvent(new Event("change"));
                }
            });
        }
        var initiallyChecked = 0;
        sessionCheckboxes.forEach(function (checkbox) {
            if (checkbox.checked) {
                initiallyChecked++;
            }
            _this.setCancelationButtonStates({
                selectedSessions: initiallyChecked,
                totalSessions: sessionCheckboxes.length,
                isSessionSelectionRequired: isSessionSelectionRequired,
                selectAllSessionsCheckbox: selectAllSessionsCheckbox,
                sessionRegistrationCancelButton: sessionRegistrationCancelButton
            });
            checkbox.addEventListener("change", function () {
                var _a;
                var checkedCheckboxes = (_a = Array.from(sessionCheckboxes).filter(function (checkbox) { return checkbox.checked; })) === null || _a === void 0 ? void 0 : _a.length;
                _this.setCancelationButtonStates({
                    selectedSessions: checkedCheckboxes,
                    totalSessions: sessionCheckboxes.length,
                    isSessionSelectionRequired: isSessionSelectionRequired,
                    selectAllSessionsCheckbox: selectAllSessionsCheckbox,
                    sessionRegistrationCancelButton: sessionRegistrationCancelButton
                });
            });
        });
    };
    EventFormRender.setCancelationButtonStates = function (_a) {
        var selectedSessions = _a.selectedSessions, totalSessions = _a.totalSessions, isSessionSelectionRequired = _a.isSessionSelectionRequired, selectAllSessionsCheckbox = _a.selectAllSessionsCheckbox, sessionRegistrationCancelButton = _a.sessionRegistrationCancelButton;
        if (selectedSessions > 0) {
            if (selectedSessions === totalSessions) {
                selectAllSessionsCheckbox.checked = true;
                sessionRegistrationCancelButton.disabled = isSessionSelectionRequired;
            }
            else {
                selectAllSessionsCheckbox.checked = false;
                sessionRegistrationCancelButton.disabled = false;
            }
        }
        else {
            sessionRegistrationCancelButton.disabled = true;
        }
    };
    EventFormRender.renderCancelationForm = function (placeholder, renderingStatus) {
        this.setSessionSelectionListeners(placeholder);
        var sessionRegistrationCancelButton = placeholder.querySelector("button[".concat(HtmlAttributes.dataEventSubmissionType, "=\"").concat(EventFormSubmissionTypes.sessionRegistrationCancellation, "\"]"));
        var eventRegistrationCancelButton = placeholder.querySelector("button[".concat(HtmlAttributes.dataEventSubmissionType, "=\"").concat(EventFormSubmissionTypes.eventRegistrationCancellation, "\"]"));
        if (sessionRegistrationCancelButton) {
            sessionRegistrationCancelButton.type = "button";
            if (renderingStatus === FormRenderingStatus.SuccessWithSessions) {
                var sessionSelectionSubtitle = placeholder.querySelector(".registrationCancellation .subtitle");
                if (sessionSelectionSubtitle) {
                    sessionSelectionSubtitle.style.display = "block";
                }
                sessionRegistrationCancelButton.addEventListener("click", function () {
                    sessionRegistrationCancelButton.type = "submit";
                });
            }
        }
        if (eventRegistrationCancelButton) {
            eventRegistrationCancelButton.type = "button";
            eventRegistrationCancelButton.addEventListener("click", function () {
                eventRegistrationCancelButton.type = "submit";
            });
        }
    };
    EventFormRender.renderSessions = function (placeholder) {
        var _a, _b, _c, _d, _e;
        var sessionContainers = placeholder.querySelectorAll("div.eventSession");
        for (var i = 0; i < sessionContainers.length; i++) {
            var sessionAvailableSeats = (_a = sessionContainers[i]) === null || _a === void 0 ? void 0 : _a.getAttribute(HtmlAttributes.dataAvailableSeats);
            var isSessionFull = parseInt(sessionAvailableSeats) <= 0;
            var sessionWaitlistAttribute = (_b = sessionContainers[i]) === null || _b === void 0 ? void 0 : _b.getAttribute(HtmlAttributes.dataWaitlistEnabled);
            var isWaitlistEnabled = sessionWaitlistAttribute === WaitlistOptions.Yes;
            var inputField = (_c = sessionContainers[i]) === null || _c === void 0 ? void 0 : _c.querySelector("input");
            if (inputField) {
                inputField.disabled = isSessionFull && !isWaitlistEnabled;
            }
            var fullSessionWarning = (_d = sessionContainers[i]) === null || _d === void 0 ? void 0 : _d.querySelector(".sessionFullMessage");
            if (fullSessionWarning) {
                fullSessionWarning.style.display = isSessionFull && !isWaitlistEnabled ? "inline" : "none";
            }
            var waitlistSessionMessage = (_e = sessionContainers[i]) === null || _e === void 0 ? void 0 : _e.querySelector(".sessionWaitlistMessage");
            if (waitlistSessionMessage) {
                waitlistSessionMessage.style.display = isSessionFull && isWaitlistEnabled ? "inline" : "none";
            }
        }
    };
    EventFormRender.setSubmissionType = function (button, submissionType) {
        button.setAttribute(HtmlAttributes.dataEventSubmissionType, submissionType);
    };
    return EventFormRender;
}());
export { EventFormRender };
